import service from "@/store/services/customer-service";

const state = {
  list: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
};

const actions = {
  create({ _ }, params) {
    return service
      .create(params)
      .then(({customer}) => {
        return Promise.resolve(customer);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  read({ commit }, params) {
    return service
      .read(params)
      .then(({ customers }) => {
        commit("SET_LIST", customers);
      })
      .catch((error) => {
        return Promise.resolve(error);
      });
  },
  update({ _ }, params) {
    return service
      .update(params)
      .then(({customer}) => {
        return Promise.resolve(customer);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  destroy({ _ }, id) {
    return service
      .destroy(id)
      .then(({customer}) => {
        return true;
      })
      .catch((error) => {
        return false;
      });
  },
  get({ _ }, id) {
    return service
      .get(id)
      .then(({customer}) => {
        return Promise.resolve(customer);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  createEndUser({ _ }, params) {
    return service
      .createEndUser(params)
      .then(({end_user}) => {
        return Promise.resolve(end_user);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  updateEndUser({ _ }, params) {
    return service
      .updateEndUser(params)
      .then(({end_user}) => {
        return Promise.resolve(end_user);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  exportCsv({ _ }, params) {
    return service
      .exportCsv(params)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  exportMetricsCsv({ _ }, params) {
    return service
      .exportMetricsCsv(params)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  importCsv({ _ }, params) {
    return service.importCsv(params);
  },
  register({ _ }, params) {
    return service
      .register(params)
      .then(({customer}) => {
        return Promise.resolve(customer);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
};

const getters = {
  list: (state) => state.list,
};

const customer = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default customer;
